import React from "react"

import WidgetCheckoutFlowPackageSelection from "~widget/components/widget-checkout-flow/widget-checkout-flow-package-selection"
import BottomDrawer from "~components/shared/drawers/bottom-drawer"

interface Props {
    readonly isOpen?: boolean
    readonly onClose: () => void
}

export default function WidgetListingPackagesDrawer({
    isOpen,
    onClose,
}: Props) {
    return (
        <BottomDrawer
            isOpen={isOpen}
            onClose={onClose}
            shouldHaveHorizontalPadding
        >
            <WidgetCheckoutFlowPackageSelection />
        </BottomDrawer>
    )
}
